module.exports = __webpack_public_path__ + "static/media/ARS.d4bb0bf0.svg";